import {useTheme} from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import * as React from 'react';
import ListOrNoElements from '../ListOrNoElements';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import AvatarPlayButton from "../audio/AvatarPlayButton";
import AvatarTextNote from "../audio/AvatarTextNote";
import {FileAvatarIcon} from "../FileAvatarIcon";
import NotesSearchResultsListItem from "./NotesSearchResultsListItem";

export default function NotesSearchResultsList({
                                                 noteSearchResults,
                                                 isRetrievingData,
                                                 listStyles,
                                                 audioNotesOwner
                                               }) {
  const theme = useTheme();
  const style = styles(theme);

  const renderListElement = (noteSearchResult, index) => {
    const note = noteSearchResult.entry;
    const text = noteSearchResult.textExtract;
    return (
      <Box key={`note-${index}`}>
        {note.isAudio && <NotesSearchResultsListItem
          avatarIcon={<AvatarPlayButton audioScr={note.publicUrl} audioOwner={audioNotesOwner} small/>}
          linkToNote={audioNotesOwner.seeNotePath()}
          note={note}
          text={text}
          linkShareInfo={{audioEntryId: note.shared_id, owner: audioNotesOwner}}
        />
        }
        {note.isText && <NotesSearchResultsListItem
          avatarIcon={<AvatarTextNote small/>}
          linkToNote={'text_note'}
          note={note}
          text={text}
          linkShareInfo={{textNoteId: note.shared_id}}
        />}
        {note.isFile && (
          <NotesSearchResultsListItem
            avatarIcon={<FileAvatarIcon note={note} small/>}
            linkToNote={`image/${note.shared_id}`}
            note={note}
            text={text}
            linkShareInfo={{imagePath: note.publicUrl, creationDate: note.creationDate}}
          />)}
        {index < noteSearchResults.length - 1 && <Divider component="li"/>}
      </Box>
    );
  };

  return (
    <ListOrNoElements noElementIcon={SearchOffIcon}
                      elements={noteSearchResults}
                      isRetrievingData={isRetrievingData}
                      listStyle={{...style.notesList, ...listStyles}}
                      renderElement={renderListElement}
                      noElementMessage={'No se encontraron resultados'}/>
  );
}

const styles = (theme) => ({
  notesList: {
    width: '100%',
    backgroundColor: theme.colors.white,
    borderRadius: '5px',
    gap: '4px'
  },
  noElementsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.padding.box,
    gap: '1rem',
    borderRadius: '5px',
    color: theme.colors.white,
    backgroundColor: theme.colors.lightBackground,
    border: `1px solid ${theme.colors.gray}`,
    width: '100%',
  },
  avatarStyle: {
    height: '40px',
    width: '40px',
  }
});